import axios from 'axios'
import {ResponseObjectUploadId, ResponseObjectUploadPercent} from '../model'
const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL

export function getLoadMasiveId() {
  // --- primer servicio para obtener el id a asociar al archivo
  return axios.get<ResponseObjectUploadId>(`${BASEURL}/bulkLoad/getBulkLoad_Id`)
}

export function getLoadPercentage(id: string) {
  return axios.get<ResponseObjectUploadPercent>(
    `${BASEURL}/bulkLoad/getBulkLoad_Progress?bulkLoadId=${id}`,
  )
}
